module.exports = __webpack_public_path__ + "img/sleeve_binding.8cbad4dd.png";